<template>
  <a href="#" class="scroll-to-top" :class="{'active': active}" @click.prevent="scrollToTop">
    <i class="fas fa-arrow-up"></i>
  </a>
</template>

<script>
/* Mixins */
import {Default} from '@mixins/Default';

/* Logic */
export default {
  name: 'ScrollToTop',
  mixins: [Default],
  props: [
    'data'
  ],
  data: function () {
    return {
      active: false,
    }
  },
  methods: {
    handleScroll() {
      window.pageYOffset ? this.active = true : this.active = false;
    },
    scrollToTop: function () {
      scroll({
        top: 0,
        behavior: "smooth"
      });
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  }
}
</script>

<style lang="scss" scoped>
@import "@css/core/_variables.scss";
@import "@css/mixins/_breakpoints.scss";
@import "@css/mixins/_functions.scss";

.scroll-to-top {
  position: fixed;
  right: 48px;
  bottom: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: $color-1;
  border-radius: 50%;
  opacity: 0;

  // Mobile
  @include media-breakpoint-down(sm) {
    display: none;
  }

  &.active {
    opacity: 1;
  }

  &:hover,
  &:focus,
  &:active,
  &:focus:active,
  {
    background-color: darken($color-1, 5%);
  }

  i {
    color: $white;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/App/Partials/ScrollToTop.vue